<div class="xuatkho-form-container">
  <!-- Form Content -->
  <div class="form-content">
    <!-- Row 1: Kho -->
    <div class="row form-group">
      <div class="col-md-12">
        <label class="form-label required-label">
          {{'Kho' | translate}}
        </label>
        <ng-select #slKho
                   class="custom-select-red"
                   [tabIndex]="2"
                   [openOnEnter]="false"
                   [items]="dskhohangs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.KhoHangId">
          <ng-template ng-footer-tmp>
            <a (click)="AddKhoHang()" class="add-new-link-red">+ Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Row 2: Quyển số & Số phiếu -->
    <div class="row form-group">
      <div class="col-md-6">
        <label class="form-label">{{'Quyển số' | translate}}</label>
        <input type="text" 
               tabIndex="3" 
               class="form-control custom-input" 
               placeholder="Nhập quyển số" 
               [(ngModel)]="doituongSelect.QuyenSo">
      </div>
      <div class="col-md-6">
        <label class="form-label">{{'Số phiếu' | translate}}</label>
        <input class="form-control custom-input"
               maxlength="20"
               tabindex="4"
               currencyMask
               [(ngModel)]="doituongSelect.SoPhieu"
               name="value"
               placeholder="Nhập số phiếu"
               [options]="ngxCurrencyOption2s" 
               autocomplete="off" />
      </div>
    </div>

    <!-- Row 3: Ngày thu tiền & Ngày phát -->
    <div class="row form-group">
      <div class="col-md-6">
        <label class="form-label">{{'Ngày thu tiền' | translate}}</label>
        <kendo-dateinput tabindex="5" 
                         placeholder="Chọn ngày thu tiền" 
                         class="custom-datepicker-red"
                         [format]="'dd/MM/yyyy'" 
                         [(value)]="doituongSelect.NgayThuTien">
        </kendo-dateinput>
      </div>
      <div class="col-md-6">
        <label class="form-label">{{'Ngày phát' | translate}}</label>
        <kendo-dateinput tabindex="6" 
                         placeholder="Chọn ngày phát" 
                         class="custom-datepicker-red"
                         [format]="'dd/MM/yyyy'" 
                         [(value)]="doituongSelect.Ngay">
        </kendo-dateinput>
      </div>
    </div>

    <!-- Row 4: Đăng ký & Phương thức -->
    <div class="row form-group">
      <div class="col-md-6">
        <label class="form-label required-label">{{'Đăng ký' | translate}}</label>
        <ng-select #slDangKy
                   class="custom-select-red"
                   [tabIndex]="9"
                   [openOnEnter]="false"
                   [items]="inputdangkys"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.DangKy"
                   (change)="changeDangKy($event)">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label required-label">{{'Phương thức' | translate}}</label>
        <ng-select #slPhuongThuc
                   class="custom-select-red"
                   [tabIndex]="10"
                   [openOnEnter]="false"
                   [items]="inputphuongthucs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.PhuongThuc">
          <ng-template ng-footer-tmp>
            <a (click)="AddKhoHang()" class="add-new-link-red">+ Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Row 5: Sản phẩm -->
    <div class="row form-group">
      <div class="col-md-12">
        <label class="form-label required-label">{{'Sản phẩm' | translate}}</label>
        <ng-select #slSanPham
                   class="custom-select-red"
                   [tabIndex]="11"
                   [openOnEnter]="false"
                   [items]="dssanphams"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   (change)="changeSanPham($event)"
                   [(ngModel)]="doituongSelect.SanPhamId">
          <ng-template ng-footer-tmp>
            <a (click)="AddSanPham()" class="add-new-link-red">+ Thêm mới</a>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Row 6: Số lượng, Đơn giá, Phải thu -->
    <div class="row form-group">
      <div class="col-md-4">
        <label class="form-label">Số lượng</label>
        <input class="form-control custom-input"
               maxlength="20"
               tabindex="12"
               currencyMask
               [(ngModel)]="doituongSelect.SoLuong"
               (ngModelChange)="changeDonGia()"
               name="value"
               placeholder="Nhập số lượng"
               [options]="ngxCurrencyOptions" 
               autocomplete="off" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Đơn giá</label>
        <input class="form-control custom-input"
               maxlength="20"
               tabindex="13"
               currencyMask
               [(ngModel)]="doituongSelect.DonGia"
               (ngModelChange)="changeDonGia()"
               name="value"
               placeholder="Nhập đơn giá"
               [options]="ngxCurrencyOptions" 
               autocomplete="off" />
      </div>
      <div class="col-md-4">
        <label class="form-label">Phải thu</label>
        <input class="form-control custom-input amount-highlight"
               maxlength="20"
               tabindex="14"
               currencyMask
               [(ngModel)]="doituongSelect.SoTien"
               name="value"
               placeholder="Tổng tiền"
               [options]="ngxCurrencyOptions" 
               autocomplete="off" 
               readonly />
      </div>
    </div>

    <!-- Row 7: Ghi chú -->
    <div class="row form-group">
      <div class="col-md-12">
        <label class="form-label">Ghi chú</label>
        <textarea type="text" 
                  tabIndex="15" 
                  rows="3" 
                  class="form-control custom-textarea" 
                  placeholder="Nhập ghi chú (nếu có)" 
                  [(ngModel)]="doituongSelect.GhiChu">
        </textarea>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="form-footer">
    <div class="footer-left">
      <div class="custom-checkbox-red" style=" display: flex;">
        <label>
          <input tabIndex="8" type="checkbox" [(ngModel)]="doituongSelect.DaThanhToan" />
          <span class="checkmark"></span>
          <span class="checkbox-label-text">{{'Thanh toán' | translate}}</span>
        </label>
        <small class="helper-text">Hệ thống tự động sinh phiếu thu tiền</small>
      </div>
    </div>
    <div class="footer-right">
      <button class="btn btn-cancel" (click)="closeModal()">
        {{'Hủy bỏ' | translate}}
      </button>
      <button type="submit" class="btn btn-save-red" (click)="saveproduct()">
        {{'Lưu lại' | translate}}
      </button>
    </div>
  </div>
</div>


<!--<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)">
    </ejs-filemanager>
  </ejs-dialog>
</div>-->
<bs-modal #mdKhoHang class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới kho hàng</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdKhoHang.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-khohangedit #dtekhohangedit (save)="saveModal_Kho($event)"></app-danhmuc-khohangedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdNhaCungCap class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới nhà cung cấp</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdNhaCungCap.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-nhacungcapedit #dtenhacungcapedit (save)="saveModal_NhaCungCap($event)"></app-danhmuc-nhacungcapedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #mdSanPham class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Thêm mới sản phẩm</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdSanPham.close()">
      <span aria-hidden="true">×</span>
    </button><!---->
  </div>
  <bs-modal-body>
    <app-danhmuc-sanphamedit #dtesanphamedit (save)="saveModal_SanPham($event)"></app-danhmuc-sanphamedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdChonHocVien class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn học sinh</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonHocVien.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chonhocvienedit #chonhocvienedit (save)="saveModal($event)"></app-tonghop-chonhocvienedit>
  </bs-modal-body>
</bs-modal>
